import _ from 'lodash';
import store from '../../../redux/store';

export const setSectionListKey = (setSelected, selectedSection) => {
  const { sections } = store.getState().shopReducer;
  _.find(sections, (section, key) => {
    if (String(section.key) === String(selectedSection)) {
      setSelected(key);
      return true;
    }
  });
};
